import type { CustomElement } from "./utils";

/*                                                                        */
export const extendElementWithInputBehavior = (
  Base: CustomElement,
): CustomElement<{
  /**
 *
 *
 */
  defaultValue: string;
  /**
 *
 *
 */
  defaultChecked: boolean;
}> =>
  class extends Base {
    get defaultValue(): string {
      return this.getAttribute("value") ?? "";
    }

    set defaultValue(value: string) {
      this.setAttribute("value", value);
    }

    get defaultChecked(): boolean {
      return this.hasAttribute("checked");
    }

    set defaultChecked(value: boolean) {
      if (value) {
        this.setAttribute("checked", "");
      } else {
        this.removeAttribute("checked");
      }
    }
  };
